import home from './home'

const lang = {

    home
}
export default lang